// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCFXz1rF47vALhbY6vT7guynYHFOfCFvYo",
  authDomain: "mchacks-de42d.firebaseapp.com",
  projectId: "mchacks-de42d",
  storageBucket: "mchacks-de42d.appspot.com",
  messagingSenderId: "290416896059",
  appId: "1:290416896059:web:4862455587f7798f60141e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage= getStorage(app)